export function formatDate(value) {
    return new Date(value).toLocaleDateString();
}

export function firstCharUppercase(value) {
    if (!value) return "";
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export function upper(value) {
    return value.toUpperCase();
}

export function formatPrice(value, decimal = 0) {
    const val = (value / 1).toFixed(decimal).replace(' ', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function prevQuarter() {
    const today = new Date();
    const month = today.getMonth();
    let currentMonthQuarter = Math.floor(month / 3) + 1;
    if (currentMonthQuarter == 1) {
        currentMonthQuarter = 4;
    } else {
        currentMonthQuarter -= 1;
    }
    return currentMonthQuarter;
};


export function currentQuarter() {
    const today = new Date();
    const month = today.getMonth();
    let currentMonthQuarter = Math.floor(month / 3) + 1;
    return currentMonthQuarter;
};

